module.exports = __webpack_public_path__ + "assets/9d198a4315884b4b313f807ab99c2071.png";